import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { toast } from "wc-toast";
import { useLocation, useParams, Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import constant from "../utils/constants";
import { compact, isEmpty, startCase } from "lodash";
import AuthContext from "../context/AuthContext";
import helpers from "../utils/helpers";
import moment from "moment";

const NagadSms = () => {
  const parmas = useParams();
  const location = useLocation();
  const user_params = compact(location.pathname.split("/"));
  let { user } = useContext(AuthContext);
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    keyword: "",
    created_by: parmas.id ? parmas.id : user?._id,
    userType: parmas.user_type ? parmas.user_type : user?.userType
  });

  const handlePageClick = (event) => {
    let obj = {
      ...filter,
      page: event.selected + 1,
      limit: filter?.limit,
    };
    setFilter(obj);
    getData(obj);
  };

  const getData = async (obj = filter) => {
    if (obj.filterByDay != "") {
      if (obj.filterByDay == "today") {
        obj.startDate = currentDate;
        obj.endDate = currentDate;
      }
      if (obj.filterByDay == "yesterday") {
        obj.startDate = previousDate;
        obj.endDate = currentDate;
      }
    }
    obj = {...obj,type:"nagad"}
    let path = apiPath.userSMSList;
    try {
      const { status, data: response_users } = await apiGet(path, obj);
      if (status === 200) {
        if (response_users.success) {
          setData(response_users?.results?.data);
          setPageCount(response_users?.results?.totalPages);
        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <section className="main-inner-outer py-4">
        <Container fluid>
          <Row>
            <div className="db-sec">
              <h2 className="common-heading">Nagad SMS</h2>
            </div>
            <Col md={12}>
              <div className="inner-wrapper">
                <Form className="bet_status">
                  <Row>
                    <Col xl={12} md={12}>
                      <Row>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0 pe-3 "
                        >
                          <Form.Group className="position-relative">
                            <Form.Control
                              type="text"
                              placeholder="Keyword"
                              value={filter?.keyword}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  keyword: e.target.value,
                                })
                              }
                            />
                          </Form.Group>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0 pe-3 "
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="px-2">From</Form.Label>
                            <Form.Group className="form-group">
                              <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.fromPeriod}
                                type="date"
                              />
                              <Form.Control
                                className="small_form_control"
                                type="text"
                                placeholder="00:00"
                                disabled
                              />
                            </Form.Group>
                          </div>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0 ps-3"
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="px-2">To</Form.Label>
                            <Form.Group className="form-group">
                              <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                min={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                        .toISOString()
                                        .split("T")[0]
                                    : new Date()
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.toPeriod}
                                type="date"
                              />
                              <Form.Control
                                className="small_form_control"
                                type="text"
                                placeholder="23:59"
                                disabled
                              />
                            </Form.Group>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div className="history-btn mt-2">
                    <ul className="list-unstyled mb-0">
                      <li>
                        <Button
                          className={
                            filter.filterByDay === "today"
                              ? "me-0 theme_dark_btn"
                              : "me-0 theme_light_btn"
                          }
                          onClick={(e) =>
                            setFilter({
                              ...filter,
                              filterByDay: "today",
                            })
                          }
                        >
                          Just For Today
                        </Button>
                      </li>
                      <li>
                        <Button
                          className={
                            filter.filterByDay === "yesterday"
                              ? "me-0 theme_dark_btn"
                              : "me-0 theme_light_btn"
                          }
                          onClick={(e) =>
                            setFilter({
                              ...filter,
                              filterByDay: "yesterday",
                            })
                          }
                        >
                          From Yesterday
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="me-0 theme_light_btn theme_dark_btn"
                          onClick={() => getData()}
                        >
                          Search
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="me-0 theme_light_btn"
                          onClick={() => {
                            setFilter({
                              page: 1,
                              page_size: 10,
                              fromPeriod: previousDate,
                              toPeriod: currentDate,
                              filterByDay: "",
                              created_by: parmas.id ? parmas.id : user?._id,
                              userType: parmas.user_type
                                ? parmas.user_type
                                : user?.userType,
                            });
                            getData({
                              page: 1,
                              page_size: 10,
                              fromPeriod: previousDate,
                              toPeriod: currentDate,
                              filterByDay: "",
                              created_by: parmas.id ? parmas.id : user?._id,
                              userType: parmas.user_type
                                ? parmas.user_type
                                : user?.userType
                            });
                          }}
                        >
                          Reset
                        </Button>
                      </li>
                    </ul>
                  </div>
                </Form>
              </div>
            </Col>

            <Col md={12} sm={12} lg={12} className="mt-2">
              <section className="account-table aprofit-downline-sms">
                <div className="responsive transaction-history">
                  <Table>
                    <thead>
                      <tr>
                        <th scope="col">Sender</th>
                        <th scope="col">Message</th>
                        <th scope="col">Transaction ID</th>
                        <th scope="col">Last Balance</th>
                        <th scope="col">Deposit</th>
                        <th scope="col">Commision</th>
                        <th scope="col">Final Balance</th>
                        <th scope="col">Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && data?.length > 0 ? (
                        data?.map((item, index) => {

                          // item.smsBody; //
                          const lastSms = (data[index + 1])?data[index + 1].smsBody:data[index].smsBody;
                          const transactionString = item.smsBody; //`Cash Out Received. Amount: Tk 500.00 Customer: 01323355387 TxnID: 7310SLQX Comm: Tk 2.05 Balance: Tk 3635.74 30/06/2024 22:37`; //item.smsBody;
                          console.log(index, transactionString, lastSms);
                          
                          // Define regular expression patterns for each detail
                          const amountPattern = /Amount: Tk (\d+\.\d{2})/;
                          const customerPattern = /Customer: (\d+)/;
                          const txnIDPattern = /TxnID: (\w+)/;
                          const commPattern = /Comm: Tk (\d+\.\d{2})/;
                          const balancePattern = /Balance: Tk (\d+\.\d{2})/;
                          const datePattern = /(\d{2}\/\d{2}\/\d{4})/;
                          const timePattern = /(\d{2}:\d{2})/;

                          // Extract each detail using the corresponding pattern
                          const amountMatch = transactionString.match(amountPattern);
                          const customerMatch = transactionString.match(customerPattern);
                          const txnIDMatch = transactionString.match(txnIDPattern);
                          const commMatch = transactionString.match(commPattern);
                          const balanceMatch = transactionString.match(balancePattern);
                          const dateMatch = transactionString.match(datePattern);
                          const timeMatch = transactionString.match(timePattern);

                          const oldBalanceMatch = lastSms.match(balancePattern);

                          // Create an object to hold the extracted details
                          const details = {
                              amount: amountMatch ? amountMatch[1] : null,
                              customer: customerMatch ? customerMatch[1] : null,
                              txnID: txnIDMatch ? txnIDMatch[1] : null,
                              comm: commMatch ? commMatch[1] : 0,
                              balance: balanceMatch ? balanceMatch[1] : 0,
                              date: dateMatch ? dateMatch[0] : null,
                              time: timeMatch ? timeMatch[0] : null,
                          };

                          // console.log(details);

                          // //Cash Out Received. Amount: Tk 200.00 Customer: 01973059640 TxnID: 731089PI Comm: Tk 0.82 Balance: Tk 189270.89 30/06/2024 21:46
                          // const commissionR = /Comm: Tk (\d{1,3}(,\d{3})*\.\d{2})/;
                          // const BalanceR = /Balance: Tk (\d{1,3}(,\d{3})*\.\d{2})/;
                          // const cnumberR = /Customer: (\w+)/;
              
                          // // Extract values using regular expressions
                          // const commissionData = item.smsBody.match(commissionR);
                          // const commission = (commissionData && commissionData.length>0)?commissionData[1]:0;
                          // const BalanceData = item.smsBody.match(BalanceR);
                          // const amount = (BalanceData && BalanceData.length>0)?BalanceData[1]:0;
                          // const cnumberData = item.smsBody.match(cnumberR);
                          // const cnumber = (cnumberData && cnumberData.length>0)?cnumberData[1]:0;

                          return (
                            <tr key={index + 1}>
                              <td>{item.sender}{(details?.customer && ` || ${details?.customer}`)}</td>
                              <td>{item.smsBody}</td>
                              <td>{item.transactionId}</td>
                              <td>{oldBalanceMatch ? oldBalanceMatch[1] : 0}</td>
                              <td>{item?.amount}</td>
                              <td>{details?.comm}</td>
                              <td>{details?.balance}</td>
                              <td>{details?.date} {details?.time}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={12}>
                            <span>You have no bets in this time period.</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel=" >"
                      forcePage={viewpage}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      previousLabel="< "
                      renderOnZeroPageCount={null}
                      activeClassName="p-0"
                      activeLinkClassName="pagintion-li"
                    />
                  </div>
                </div>
              </section>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default NagadSms;